<template>
  <base-container>
   <ArtisanGrid metaKey="SysParamInfo">
  </ArtisanGrid>
  </base-container>
</template>

<script>
export default {};
</script>

<style>
</style>